import { isApple } from '../../utils';

export const getUndoHotkey = (): string => 'mod+z';
export const getRedoHotkey = (): string | string[] => (isApple() ? 'cmd+shift+z' : 'ctrl+y');
